import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { requestLogin, requestLogout, userSelector } from '../appStore/commonSlice';
import {
  AUTENTICARLOGOUTURLAFIP,
  AUTENTICARLOGOUTURLMIARGENTINA,
  AUTENTICARURLAFIP,
  AUTENTICARURLMIARGENTINA,
} from '../const';
import AFIP from '../img/ARCA.png';
import { setNotification } from './GlobalFeedback/feedbackSlice';

const Login = (props) => {
  const history = useHistory();
  const location = useLocation();
  const newLocation = {
    ...location,
    state: {},
  };

  const handleAutenticarUsuarioAFIP = () => {
    if (!auth) window.location.href = AUTENTICARURLAFIP;
    else logout();
  };

  const handleAutenticarUsuarioMiArgentina = () => {
    if (!auth) window.location.href = AUTENTICARURLMIARGENTINA;
    else logout();
  };

  const [showModal, setShowModal] = useState(false);
  const [setErrorMsg] = useState('');

  const user = useSelector(userSelector);
  const dispatch = useDispatch();
  const auth = user.token;

  useEffect(() => {
    const enabledFromUrl = location.state?.toLogin;
    setShowModal(enabledFromUrl);
  }, [location]);

  const toggleModal = (toggle) => {
    setErrorMsg('');
    setShowModal(toggle);
    if (!toggle) history.push('/');
  };

  const logout = () => {
    dispatch(requestLogout()).then(() => {
      {
        if (localStorage.getItem('origen') === 'AFIP') {
          localStorage.removeItem('origen');
          window.location.replace(AUTENTICARLOGOUTURLAFIP);
        } else if (localStorage.getItem('origen') === 'MIARGENTINA') {
          localStorage.removeItem('origen');
          window.location.replace(AUTENTICARLOGOUTURLMIARGENTINA);
        }
      }
    });
  };

  const login = (cuil, password) => {
    dispatch(
      requestLogin({
        cuil,
        password,
      }),
    ).then((res) => {
      if (res.error) {
        setErrorMsg(res.error.message);
      } else {
        dispatch(
          setNotification({
            variant: 'success',
            msg: 'Login exitoso.',
          }),
        );
        toggleModal(false);

        const location = {
          pathname: '/',
        };
        history.push(location);
      }
    });
  };

  const text = auth ? 'Salir' : 'Ingresar';

  return (
    <>
      <div className="d-flex align-items-center mx-2">
        {!auth ? (
          <>
            {/* BOTON MI ARGENTINA */}
            <ReactTooltip id="botonMiArgentina" place="bottom" effect="solid" />
            <Button
              // variant="link"
              type="button"
              className="btn btn-newPrimary"
              onClick={() => {
                handleAutenticarUsuarioMiArgentina();
              }}
              data-tip={'Ingresar con miArgentina'}
              data-for="botonMiArgentina">
              miArgentina
              {/* <img src={miArgentina} alt="miArgentina" width={70} /> */}
            </Button>
            {/* BOTON AFIP */}
            <ReactTooltip id="botonAFIP" place="bottom" effect="solid" />
            <Button
              variant="link"
              onClick={() => {
                handleAutenticarUsuarioAFIP();
              }}
              data-tip={'Ingresar con AFIP'}
              data-for="botonAFIP">
              <img src={AFIP} alt="AFIP" width={70} />
            </Button>
          </>
        ) : (
          <Button
            variant="link"
            onClick={() => {
              handleAutenticarUsuarioAFIP();
            }}>
            {text}
          </Button>
        )}
      </div>
    </>
  );
};

export default Login;
